import React, { useEffect } from "react";
import useGlobal from "store";
import PanelHeader from "components/PanelHeader/PanelHeader";
import { Row, Col, Card, CardHeader, CardBody, Table } from "reactstrap";
import Switch from "react-bootstrap-switch";


const Publishers = (props) => {

    const [user, actions] = useGlobal(
      state => state.user,
      actions => actions
    );

    const publishers = [
        {
            name: 'The Street',
            domain: 'thestreet.com',
            date_agreed: '2023-09-11 12:05:33',
            is_disabled: false
        }
    ];

    useEffect(() => {
        if(!user) {
            return;
        }
       // actions.userActions.getUserInvoices();
    }, [user, actions]);

    const handleSwitch = (elem, value) => {
        // let formFields = { ...formState };
        // formFields[elem.props.name] = value;
        // setFormState(formFields);
        // formFields.id = state.user.business.domains[0].id;
        // console.log(formFields);
        //actions.businessActions.updateBusinessDomain(formFields);
        actions.notifierActions.notify('Saved!', 'success', 'br');
    }

    useEffect(() => {
        if(!publishers) {
            return;
        }
       // actions.userActions.getUserInvoices();
    }, [publishers]);

    const publisherTable = publishers && publishers.length > 0 ? publishers.map(p => <Row className="p-3">
        <Col md="3" xs="3">
            {p.name}
        </Col>
        <Col md="3" xs="3">
            {p.domain}
        </Col>
        <Col md="3" xs="3">
            {p.date_agreed}
        </Col>
        <Col md="3" xs="3">
            <Switch defaultValue={true} value={p.is_disabled === 1 ? false : true} onChange={handleSwitch} name="is_disabled" />
        </Col>
    </Row>) : <></>;

    return (
        <>
        <PanelHeader size="sm" />
        <div className="content">
          
          {user ?
            <Row>
                <Col md="8">
                    <Card className="card-chart">
                        <CardHeader>
                            <h5 className="card-category">Publishers</h5>
                        
                        </CardHeader>
                        <CardBody>
                        <Table responsive>
                            <thead>
                            <Row className="p-3">
                                <Col md="3" xs="3">
                                    <strong>Name</strong>
                                </Col>
                                <Col md="3" xs="3">
                                    <strong>Domain</strong>
                                </Col>
                                <Col md="3" xs="3">
                                    <strong>Agreement Date</strong>
                                </Col>
                                <Col md="3" xs="3">
                                    <strong>StreemPay Active</strong>
                                </Col>
                            </Row>
                            </thead>
                            <tbody>{publisherTable}</tbody>
                        </Table>
                        </CardBody>
                    </Card>
                </Col>
                <Col md="4">
                    
                </Col>
            </Row> : <></> }
        </div>
        
        </>
    );
}

export default Publishers;